/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateCommitGitDetails {
    getFixupPrototypeFunction() { return TemplateCommitGitDetails.fixupPrototype; }

    static newInstance(model: Partial<TemplateCommitGitDetails>): TemplateCommitGitDetails {
        let obj = Object.assign(new TemplateCommitGitDetails(), model);
        TemplateCommitGitDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateCommitGitDetails>): TemplateCommitGitDetails {
        if (!model) return null;
        return TemplateCommitGitDetails.newInstance(<TemplateCommitGitDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateCommitGitDetails) {
        if (!obj) return;

        models.TemplateCommitGitDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateCommitGitDetails): boolean {
        Object.setPrototypeOf(obj, TemplateCommitGitDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * File type to commit - Terraform module wrapper or JSON variables file
     */
    commit_file_type: models.TemplateCommitFileType;

    /**
     * Create a new file, or update an existing one
     */
    file_state: models.TemplateCommitFileState;

    /**
     * Path to the existing file to update. Required when file_state='existing'
     */
    file_path: string;

    /**
     * Git branch or tag the generated module source should reference
     */
    release: string;

    /**
     * Commit message
     */
    commit_message: string;

}
